import { Icon } from "@circle-react-shared/Icon";
import type { NotificationActionType } from "@circle-react/types/Notification";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

export interface NotificationTypeIconProps {
  action: NotificationActionType;
}

type V3IconType =
  | "16-like-v3"
  | "16-message-v3"
  | "16-mention-v3"
  | "16-post-v3"
  | "16-reply-v3"
  | "16-alert-v3"
  | "16-live-v3";

const getIconType = (action: NotificationActionType): V3IconType | null => {
  switch (action) {
    case "like":
      return "16-like-v3";
    case "message":
      return "16-message-v3";
    case "mention":
      return "16-mention-v3";
    case "add":
      return "16-post-v3";
    case "comment_to_author":
    case "comment":
      return "16-message-v3";
    case "reply":
      return "16-reply-v3";
    case "flag":
    case "community_member_flagged_post":
    case "community_member_flagged_comment":
    case "community_member_flagged_connection":
    case "community_member_flagged_message":
    case "flagged_community_member_new_post":
    case "flagged_community_member_new_comment":
    case "profanity_filter_flagged_post":
    case "profanity_filter_flagged_comment":
      return "16-alert-v3";
    case "live_stream_went_live":
      return "16-live-v3";
    default:
      return null;
  }
};

export const NotificationTypeIcon = ({ action }: NotificationTypeIconProps) => {
  const { isCircleV4 } = useCircleV4();
  const v3Icon = getIconType(action);

  if (v3Icon) {
    if (isCircleV4) {
      return (
        <div className="absolute left-5 top-5 z-0 flex size-4 items-center justify-center rounded-full text-white">
          <Icon type={v3Icon} size={16} />
        </div>
      );
    }

    return (
      <div className="absolute left-6 top-6 z-0 flex size-4 items-center justify-center rounded-full text-white">
        <Icon type={v3Icon} size={16} />
      </div>
    );
  }

  return null;
};
